import { Delivery } from "@carbon/icons-react";
import { Typography } from "@mui/material";
import { Package } from "react-feather";
import { useTranslation } from "react-i18next";

import { InboundDeliveryStatus } from "../../models/autogenerated-deliveryService-gql/graphql";
import DeliveryStatusBadge from "../../pages/outboundDeliveriesOverview/components/deliveryStatusBadge/DeliveryStatusBadge";

interface IOrderHeaderProps {
  status: InboundDeliveryStatus;
  amount: number;
  paddingBottom?: string;
}

const OrderHeader = (props: IOrderHeaderProps) => {
  const { t } = useTranslation();

  const { status, amount, paddingBottom } = props;

  return (
    <div
      style={{ paddingBottom: paddingBottom }}
      className="page-content-row"
      data-testid="orderHeader"
    >
      <div className="page-content-row-item-max-space">
        <div className="mr-10">
          <Delivery size={24} />
        </div>
        <div className="page-content-row-item page-content-row-item-large-font">
          {t("delivery")}
        </div>
      </div>
      <div className="page-content-row-item-max-space page-content-row-item-center">
        <div className="page-content-row-item-text-right mr-2">
          <Typography>
            <Package size={24} />
          </Typography>
        </div>
        <div className="page-content-row-item ml-2">
          <Typography>{amount}</Typography>
        </div>
      </div>
      <div className="page-content-row-item-max-space page-content-row-item-right">
        <DeliveryStatusBadge status={status} />
      </div>
    </div>
  );
};

export default OrderHeader;
